import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import AnalyticObserver from './AnalyticObserver';
import AdobeLaunch from './AdobeLaunch';
import GoogleTagManager from './GoogleTagManager';

export default class AnalyticEngine extends PureComponent {
    static propTypes = {
        appConfig: PropTypes.object,
    };

    render() {
        const { appConfig = {} } = this.props;
        const { featureConfig = {} } = appConfig;
        const {
            adobeLaunch: { url: alUrl = '', ...alRest } = {},
            googleTagManager: { url: gtmUrl = '', ...gtmRest } = {},
        } = featureConfig;

        return (
            <>
                <AnalyticObserver onEvent={this.handleEvent} />
                {alUrl && (
                    <AdobeLaunch
                        url={alUrl}
                        {...alRest}
                        appConfig={appConfig}
                        onInitialized={this.handleRegisterHandler}
                    />
                )}
                {gtmUrl && <GoogleTagManager url={gtmUrl} {...gtmRest} />}
            </>
        );
    }

    handlers = [];

    handleRegisterHandler = (eventHandler) => {
        if (!this.handlers.includes(eventHandler)) {
            this.handlers.push(eventHandler);
        }
    };

    /* istanbul ignore next */ // this is an internal call - not sure how to expose to test
    handleEvent = (eventName, options) => {
        this.handlers.forEach((handler) => handler(eventName, options));
    };
}
